/* Notas por ingrediente (cumplimiento: qué ES y qué aporta al color/sabor - nunca beneficios de salud).
   Claves en minúscula y sin acentos; se casan por subcadena contra la lista de ingredientes de MC_DATA. */
window.MC_ING_NOTES = {
  "matcha": "Té verde japonés molido a piedra - se bebe la hoja entera. Aporta el verde y su cafeína natural con L-teanina.",
  "chlorella": "Alga verde de agua dulce en polvo. Refuerza el verde con un fondo vegetal.",
  "espinaca": "Verdura de verdad, deshidratada. Color verde y suavidad.",
  "inulina": "Fibra vegetal soluble (achicoria). Da cuerpo sedoso y un ligero dulzor.",
  "lucuma": "Fruta andina con sabor a caramelo. Aporta un toque dulce y acaramelado.",
  "sal del himalaya": "Una pizca de sal rosa que realza todos los sabores.",
  "vainilla": "Aroma cálido que redondea la mezcla.",
  "kabocha": "Calabaza japonesa. Dulzor suave y color dorado.",
  "curcuma": "La raíz dorada. Pone el amarillo y el sabor cálido y terroso.",
  "te amarillo": "Té poco oxidado, suave y delicado.",
  "canela": "Corteza dulce y aromática - el abrazo del chai.",
  "cardamomo": "La especia floral y cítrica del chai auténtico.",
  "clavo": "Intensidad cálida en dosis mínimas.",
  "anis estrellado": "Dulzor anisado natural, en forma de estrella.",
  "pimienta negra": "Punto picante; compañera tradicional de la cúrcuma.",
  "jengibre": "Raíz fresca y picante, columna vertebral del chai.",
  "clitoria": "Flor azul índigo (butterfly pea). En su forma pura (pétalos), vira a morado con limón - química natural del pH.",
  "espirulina": "Ficocianina: el pigmento azul natural de la espirulina. El azul comestible más difícil.",
  "oolong": "Té semioxidado con notas florales y tostadas.",
  "cacao": "Cacao puro desgrasado. Sabor a chocolate de verdad.",
  "carbon activado": "Carbón vegetal comestible: el negro absoluto, natural.",
  "te negro": "Base con cuerpo y cafeína - el alma del chai clásico.",
  "remolacha": "Raíz magenta. Rosa natural con dulzor terroso.",
  "pitaya": "Fruta del dragón liofilizada. Rosa vibrante, sabor tropical.",
  "pu-erh": "Té rojo fermentado y añejado de Yunnan. Profundo y terroso.",
  "maca": "Raíz andina con sabor a malta y caramelo. Base cremosa del blend blanco.",
  "te blanco": "El té menos procesado: delicado y sutil.",
  "rooibos": "Infusión sudafricana naturalmente sin cafeína, dulce y cobriza.",
  "arroz tostado": "Notas a palomitas y frutos secos - el sello del genmaicha.",
  "aroma de cacao": "Refuerzo natural del sabor a chocolate.",
  "aroma de vainilla": "Refuerzo del aroma cálido de vainilla."
};
